const Generic = require("../GenericThemeFunctions")

module.exports = {
    defaultLanguage: 'es',
    scssVariables: './src/styles/douob2',
    randomNickname:  () => { return Generic.RandomNickname() },
    defaultPassword: 'default'
}